<template>
  <v-card class="py-4" flat color="primary" tile>
    <v-row no-gutters class="white--text px-6"> {{ title }} </v-row>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["eventDetails"]),
    title() {
      if (this.eventDetails) {
        switch (this.eventDetails.tipo_venda) {
          case "R":
            return "Faça sua inscrição";
          case "I":
            return "Escolha seus ingressos";
          case "D":
            return "Faça sua doação";
          default:
            return "Escolha seus ingressos";
        }
      } else return "Escolha seus ingressos";
    },
  },
};
</script>
